import React from "react";
import { Main } from "./MainStyles";
import { MaxWidthContainer } from "./MaxWidthContainer";

export const PageOuter = ({
  style,
  children,
  title,
  wideLayout,
}: {
  style?: React.CSSProperties;
  children?: React.ReactNode;
  title: string;
  wideLayout?: boolean;
}): JSX.Element => {
  return (
    <Main style={style}>
      <title>{title}</title>
      <MaxWidthContainer wideLayout={wideLayout}>{children}</MaxWidthContainer>
    </Main>
  );
};
